import { Component, OnInit, OnDestroy, ViewEncapsulation, HostListener, Input, NgZone } from '@angular/core';
import { finalize, delay } from 'rxjs/operators';
import { Observable, Subscription } from 'rxjs';
import { untilDestroyed } from 'src/app/core';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { AnalyticsService } from './analytics.service';
import { Main } from 'src/app/core/main.service';
import * as FusionCharts from 'fusioncharts';

@Component({
  selector: 'app-simulator',
  templateUrl: './simulator.component.html',
  styleUrls: ['./simulator.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class SimulatorComponent implements OnInit, OnDestroy {
  title: string;
  today: Date;
  ekub: any = {
    id: null,
    startDate: null,
    interval: 'weekly',
    endDate: null,
    ekub_id: null,
    members: [],
    membersCount: 0,
    firstAwardOn: 3,
    firstAwards: 2,
    amount: 500,
    value: 0,
    awardValue: 0,
    transactions: [],
  };
  intervals = [{ name: 'Daily', value: 'daily' }, { name: 'Weekly', value: 'weekly' }, { name: 'Monthly', value: 'monthly' }];

  rounds: any = [];
  constructor(private router: Router, private route: ActivatedRoute,
    private api: AnalyticsService, private mainService: Main) {
    this.today = new Date();
    /*  var tempStartDate = this.today.getFullYear() + '-' + (this.today.getMonth() + 1) + '-' + this.today.getDate();
     var tempEndDate = this.today.getFullYear() + 1 + '-' + (this.today.getMonth() + 1) + '-' + this.today.getDate();
     console.log("Today: " + tempStartDate);
     var startDate = new Date(tempStartDate);
     var endDate = new Date(tempEndDate); */

    this.ekub = {
      id: 1,
      ekub_id: 'EK-1010101',
      round: 1,
      amount: this.ekub.amount,
      value: 0,
      awardValue: 0,
      interval: this.ekub.interval,
      startDate: this.ekub.startDate,
      endDate: this.ekub.endDate,
      firstAwardOn: this.ekub.firstAwardOn,
      firstAwards: this.ekub.firstAwards,
      membersCount: this.ekub.membersCount,
      awardsRemaining: this.ekub.awardsRemaining,
      transactions: [{
        amount: 510,
        date: new Date("2021-08-22 03:05:00"),
        member: 1,
      },
      {
        amount: 510,
        date: new Date("2021-08-22 03:05:00"),
        member: 2,
      },
      {
        amount: 510,
        date: new Date("2021-08-22 03:05:00"),
        member: 3,
      },
      {
        amount: 510,
        date: new Date("2021-08-22 03:05:00"),
        member: 4,
      },
      {
        amount: 510,
        date: new Date("2021-08-22 03:05:00"),
        member: 5,
      },
      {
        amount: 510,
        date: new Date("2021-08-22 03:05:00"),
        member: 6,
      },
      {
        amount: 510,
        date: new Date("2021-08-22 03:05:00"),
        member: 7,
      },
      {
        amount: 510,
        date: new Date("2021-08-22 03:05:00"),
        member: 8,
      }],
      members: [{
        id: 1,
        name: 'Eyob'
      },
      {
        id: 2,
        name: 'Binyam'
      },
      {
        id: 3,
        name: 'Solomon'
      }]
    }

  }

  ngOnInit() {

  }

  initiateSimulator() {
    debugger;

    this.ekub.awardValue = this.ekub.membersCount * this.ekub.amount;
    this.ekub.value = Math.pow(this.ekub.membersCount, 2) * this.ekub.amount;
    console.log('simulating ...');
    this.rounds = [];
    var balanceBefore = 0;
    var remainingBalance = 0;
    var awardsRemaining = this.ekub.membersCount;
    for (var i = 0; i < this.ekub.membersCount + this.ekub.firstAwardOn - this.ekub.firstAwards; i++) {
      if (i < this.ekub.membersCount) {
        balanceBefore = remainingBalance += this.ekub.membersCount * this.ekub.amount;
      } else {
        balanceBefore = remainingBalance - this.ekub.membersCount * this.ekub.amount;
      }
      if (i + 1 == this.ekub.firstAwardOn) {
        remainingBalance -= (this.ekub.firstAwards * this.ekub.membersCount * this.ekub.amount);
        awardsRemaining -= this.ekub.firstAwards;
      } else if (i + 1 > this.ekub.firstAwardOn) {
        remainingBalance -= (this.ekub.membersCount * this.ekub.amount);
        awardsRemaining--;
      }
      this.rounds.push({
        round: i < this.ekub.membersCount ? i + 1 : 'N / A',
        balanceBefore: balanceBefore,
        balanceAfter: remainingBalance,
        awardsRemaining: awardsRemaining
      });
    }
    console.log("this.rounds");
    console.log(this.rounds);
  }

  calculateValue() {

  }

  getInterval(key) {
    switch (key) {
      case 'daily':
        return 'Day(s)';
      case 'weekly':
        return 'week(s)';
      case 'monthly':
        return 'Month(s)';
    }
  }

  ngOnDestroy(): void {

  }

}
